import React from "react";
import { Link } from "react-router-dom";
import { Coins, Gift, MessageCircleHeart } from "lucide-react";
import Shell from "../components/Shell";
import { useApp } from "../context/AppContext";
import { endpoints } from "../lib/api";
import { UBot } from "../components/UBot";

const STATUS = { new: "Received", reviewed: "Seen by U.Center", forwarded: "Passed to the team", in_progress: "In conversation", closed: "Wrapped up", spam: "Received" };
const TYPE_ICON = { pledge: Coins, inkind: Gift, message: MessageCircleHeart };
const CAT_LABEL = { mentorship: "Mentorship", cloud_credits: "Cloud credits", design: "Design", marketing: "Marketing", intros_network: "Intros & network", legal: "Legal", office_space: "Office space", other: "Something else" };

export default function SupportedPage() {
  const { deviceId, auth } = useApp();
  const [items, setItems] = React.useState(null);

  React.useEffect(() => { endpoints.mySupport(deviceId).then((d) => setItems(d.items)).catch(() => setItems([])); }, [deviceId, auth.authenticated]);

  const label = (it) => {
    if (it.type === "pledge") return `Pledge · ${it.currency} ${it.amount}`;
    if (it.type === "inkind") return `Offer · ${(it.categories || []).map((c) => CAT_LABEL[c] || c).join(", ")}`;
    return "Message";
  };

  return (
    <Shell>
      <div className="mx-auto w-full max-w-3xl px-4 py-6">
        <h1 className="font-display text-[28px] font-extrabold text-white">My support</h1>
        <p className="mb-5 text-on-dark-muted">Pledges, offers and messages you've sent</p>

        {items === null ? (
          <p className="text-on-dark-muted">Loading…</p>
        ) : items.length === 0 ? (
          <div className="flex flex-col items-center gap-3 py-16 text-center" data-testid="supported-empty">
            <UBot size={96} />
            <h2 className="font-display text-[22px] font-bold">You haven't backed anyone yet</h2>
            <p className="max-w-xs text-on-dark-muted">Swipe right on a project you love 💛</p>
            <Link to="/deck" className="mt-2 rounded-pill bg-gold-500 px-6 py-3 font-bold text-navy-900">Start swiping</Link>
          </div>
        ) : (
          <div className="space-y-3" data-testid="supported-list">
            {items.map((it, i) => {
              const Icon = TYPE_ICON[it.type];
              return (
                <div key={i} className="flex items-center gap-3 rounded-lg bg-white/5 p-4 ring-1 ring-white/10">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold-500/20 text-gold-400"><Icon size={18} /></span>
                  <div className="min-w-0 flex-1">
                    <Link to={`/p/${it.slug}`} className="block truncate font-display text-[16px] font-bold text-white hover:text-gold-400">{it.project}</Link>
                    <p className="truncate text-[13px] text-on-dark-muted">{label(it)}</p>
                  </div>
                  <span className="shrink-0 rounded-pill bg-mint-500/15 px-3 py-1 text-[12px] font-semibold text-mint-500">{STATUS[it.status] || "Received"}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Shell>
  );
}
